/*!
 * Media Query breakpoints events (MQBE) 2.0.3
 * Small JS lib that fires events when you enter / leave a CSS mediaquery.
 *
 * https://github.com/carloscabo/MQBE
 *
 * Copyright 2016, Carlos Cabo
 *
 * Licensed under MIT
 *
 * Released on: June 22, 2016
 */
!function(e,t){"use strict";function n(){var e=u;return u=r(),e!==u&&(c.trigger("mqbe"),c.trigger("leave."+e+".mqbe"),c.trigger("enter."+u+".mqbe")),u}function r(){var e=window.getComputedStyle(document.body,":after").getPropertyValue("content");return e.replace(/["']/g,"")}function o(){return"undefined"!=typeof window.matchMedia||"undefined"!=typeof window.msMatchMedia}function i(e,t){return window.onresize=function(){clearTimeout(t),t=setTimeout(e,250)},e}var u,c=e(document);o()&&e(function(){n(),i(function(){n()})}),window.MQBE={supported:o,current_state:r}}(jQuery);
//# sourceMappingURL=maps/mqbe.js.map
